// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6545cc1d","787":"d768e379"}[chunkId] + ".chunk.js";
};